import { VoidFunctionComponent } from 'react';
import { RoundedCornerBox } from '@/components/RoundedCornerBox';
import { Key } from '@/components/scenes/code-input/Key';

export const PINPAD_WIDTH = 4.05;
const PINPAD_HEIGHT = 3.8;

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '@', '0', 'del'] as const;

interface Props {
    onKeyPress: (code: string) => void;
}
export const PinPad: VoidFunctionComponent<Props> = ({ onKeyPress }) => (
    <>
        <RoundedCornerBox
            left={-PINPAD_WIDTH / 2}
            right={PINPAD_WIDTH / 2}
            top={PINPAD_HEIGHT / 2}
            bottom={-PINPAD_HEIGHT / 2}
            radius={0.7}
            lineWidth={4}
        />
        {KEYS.map((key, i) => (
            <Key key={i} index={i} value={key} onKeyPress={onKeyPress} />
        ))}
    </>
);
